export enum TripStatus {
    None = 0,
    Active = 1,
    Finished = 2,
    NotStarted = 3,
    Unknown = 4
}
